import {Component, OnInit} from "@angular/core";
import {IGrpdPService} from "../../../../infrastructure/privacy-policy/IGrpdPService";
import {NavigationService} from "../../../navigation/NavigationService";

export abstract class PrivacyFooterBaseComponent implements OnInit{

    public isGrpdAccepted:boolean = false;

    constructor(private grpdService:IGrpdPService, private navigationService:NavigationService){

    }

    ngOnInit(): void {
        this.grpdService.IsAccepted().then(isAccepted => {
            this.isGrpdAccepted = isAccepted;
        });
    }

    public acceptGrpd():void{
        this.grpdService.Accept();
        this.isGrpdAccepted = true;
    }

    public moreInfo(){
        window.open('privacy-policy', '_blank');
    }

}



// WEBPACK FOOTER //
// C:/Users/Benoit/WebstormProjects/schiltz/client/src/app/presentation/components/privacy-policy/footer/privacy-footer.ts